import React, { useState } from 'react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header className="bg-white shadow-md fixed w-full top-0 z-50">
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <h1 className="text-xl sm:text-2xl font-bold text-primary-700">
                АЛІБІ.НЕТ.ЮА
              </h1>
              <p className="text-xs text-gray-600 hidden sm:block">Інформаційне агентство</p>
            </div>
          </div>

          <div className="hidden md:flex space-x-8">
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-primary-600 transition-colors">
              Про нас
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-primary-600 transition-colors">
              Послуги
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-primary-600 transition-colors">
              Контакти
            </button>
          </div>

          <div className="hidden md:block">
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-primary-600 text-white px-6 py-2 rounded-lg hover:bg-primary-700 transition-colors"
            >
              Зв'язатися
            </button>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-gray-700 hover:text-primary-600"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden pb-4">
            <div className="flex flex-col space-y-3">
              <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-primary-600 text-left">
                Про нас
              </button>
              <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-primary-600 text-left">
                Послуги
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-primary-600 text-left">
                Контакти
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
